function addQuickAddToCard(card) {
  const info = card.querySelector('.card__information');
  if (!info || info.querySelector('.quick-add')) return;

  const quickAddDiv = document.createElement('div');
  quickAddDiv.className = 'quick-add no-js-hidden';
  quickAddDiv.innerHTML = `
    <product-form data-section-id="template--27457118175581__featured_collection">
      <form method="post" action="/cart/add" class="form" enctype="multipart/form-data" novalidate>
        <input type="hidden" name="form_type" value="product">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="id" value="55665953243485" class="product-variant-id">
        <button type="submit" name="add" class="quick-add__submit button button--full-width button--secondary">
          <span>Dodaj do koszyka</span>
          <span class="sold-out-message hidden">Wyprzedane</span>
          <div class="loading__spinner hidden">
            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>
        <input type="hidden" name="product-id" value="14955566203229">
        <input type="hidden" name="section-id" value="template--27457118175581__featured_collection">
      </form>
    </product-form>
  `;

  info.appendChild(quickAddDiv);
  console.log("Quick-add dodany do karty", card);
}

// Obserwujemy kontener z kafelkami
const container = document.querySelector('.card-wrapper') || document.body;

const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.classList.contains('card__content')) {
        console.log("Nowa karta dodana do DOM");
        addQuickAddToCard(node);
      } else if (node.nodeType === 1) {
        // jeśli dodano większy kontener z kilkoma kartami
        node.querySelectorAll('.card__content').forEach(card => addQuickAddToCard(card));
      }
    });
  });
});

observer.observe(container, { childList: true, subtree: true });

// Uruchamiamy raz dla już istniejących kart
document.querySelectorAll('.card__content').forEach(card => addQuickAddToCard(card));
